var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailFilled = function SvgMailFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.954 5.542c.014.158.046.301.046.458v12a5.007 5.007 0 0 1-5 5H5a5.007 5.007 0 0 1-5-5V6c0-.157.032-.3.046-.458l8.418 8.418a5.007 5.007 0 0 0 7.072 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1a4.99 4.99 0 0 1 4.256 2.411l-9.134 9.135a3.01 3.01 0 0 1-4.244 0L.744 3.41A4.99 4.99 0 0 1 5 1z"
  })));
};
export default SvgMailFilled;